import { Tooltip } from 'antd'
import { ViewItem } from './itemModel'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileInvoiceDollar } from '@fortawesome/pro-solid-svg-icons'

type Props = { item: ViewItem }

const InvoicedIcon = ({ item }: Props) => {
  if (!item.isInvoiced) {
    return <></>
  }

  return <Tooltip title="This item has been invoiced and may not be edited." placement="topLeft">
    <FontAwesomeIcon icon={faFileInvoiceDollar} style={{ marginRight: '5px' }} />
  </Tooltip>
}
export default InvoicedIcon
